<template>
  <div>
    <p
      v-if="isOnboardingRedesign"
      class="tw-mb-1 tw-text-[#4F4F4F] tw-text-sm md:tw-hidden tw-mt-8"
    >
      {{ label }}
    </p>
    <b-row :class="isOnboardingRedesign ? 'tw-flex md:tw-hidden' : 'd-lg-none tw-mt-4'">
      <b-col>
        <h3 class="bold d-letter-spacing onboarding-title">
          {{ startStep }}
        </h3>
      </b-col>
      <b-col v-if="endStep">
        <h3 class=" bold d-letter-spacing onboarding-title text-muted text-right">
          {{ endStep }}
        </h3>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  props: {
    label: {
      type: String,
    },
    startStep: {
      type: String,
    },
    endStep: {
      type: String,
    },
  },
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
  },
};
</script>
